import { combineReducers } from 'redux';
import { authentication } from './authentication.reducer';
import { alert } from './alert.reducer';
import { infosetting } from './infosetting.reducer';

const rootReducer = combineReducers({
  authentication,
  alert,
  infosetting,
});

export default rootReducer;